export const MY_TAX_FNS_PENDING_TITLE = 'Ждём ответ ФНС';

export const MY_TAX_FNS_PENDING_DESCRIPTION =
	'Мы отправили запрос на проверку данных. Нужно немного подождать';

export const MY_TAX_FNS_PENDING_ACTION_LABEL = 'Окей, жду';
